import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-waybill',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class WaybillComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/system/waybill/waybill.component.ts